'use client';

import React, { ReactNode } from 'react';

interface SingleBarProps {
  label: string;
  value: number;
  displayValue: ReactNode;
  ariaDisplayValue: string;
  maxValue: number;
  color: string;
  isMasked?: boolean;
}

const MinWidthPx = 100;
const MaxWidthPercent = 90;

const SingleBar: React.FC<SingleBarProps> = ({
  label,
  value,
  displayValue,
  ariaDisplayValue,
  maxValue,
  color,
  isMasked = false,
}) => {
  const percentage =
    maxValue > 0 && !isMasked ? (value / maxValue) * MaxWidthPercent : 0;

  return (
    <div
      className="h-4 w-full max-w-full rounded-3xl flex justify-start items-center gap-1 overflow-hidden"
      data-testid={`single-bar-${label.toLowerCase()}`}
    >
      {/* Bar */}
      <div
        className={`h-full ${color} rounded-full min-w-0 flex-shrink`}
        style={{
          width: value > 0 && !isMasked ? `${percentage}%` : `${MinWidthPx}px`,
          ...((value === 0 || isMasked) && { minWidth: `${MinWidthPx}px` }),
        }}
        role="meter"
        aria-label={`${label}: ${ariaDisplayValue}`}
        aria-valuenow={value}
        aria-valuemin={0}
        aria-valuemax={maxValue}
      />

      {/* Label outside bar */}
      <div className="text-primary text-sm font-bold font-['Inter'] leading-5 whitespace-nowrap flex-shrink-0">
        {displayValue} {label}
      </div>
    </div>
  );
};

export default SingleBar;
